import { useTranslation } from "react-i18next";
import { useApp } from "@/context/AppContext";
import { FLAG_CLASS } from "@/icons";

export function LocaleSwitcher() {
  const { t } = useTranslation();
  const { config, locale, setLocale } = useApp();

  return (
    <div className="flex flex-col items-center gap-3">
      <p className="text-[11px] font-medium text-ink-30 uppercase tracking-[0.14em]">
        {t("home.chooseLanguage")}
      </p>
      <div className="flex items-end gap-2 flex-wrap justify-center">
        {config.app.supportedLocales.map((option, index) => {
          const selected = locale === option.id || locale.startsWith(option.id);
          return (
            <div key={option.id} className="flex flex-col items-center gap-2">
              <button
                type="button"
                data-testid={`button-locale-${option.id}`}
                title={option.label}
                aria-pressed={selected}
                onClick={() => void setLocale(option.id)}
                className={`flex items-center justify-center p-2.5 rounded-xl border transition-all duration-200 cursor-pointer ${
                  selected
                    ? "border-ink-30 shadow-sm bg-ink-6"
                    : "border-ink-8 bg-transparent hover:border-ink-20 hover:bg-ink-4"
                }`}
              >
                <span
                  className={`flag-wave ${FLAG_CLASS[option.flag] ?? ""}`}
                  style={{
                    width: "1.5rem",
                    height: "1.125rem",
                    display: "block",
                    borderRadius: "2px",
                    animationDelay: `${index * 0.16}s`,
                  }}
                  aria-hidden="true"
                />
              </button>
              <span className="h-3 flex items-center justify-center">
                {selected ? (
                  <span className="text-[9px] font-semibold uppercase tracking-[0.18em] text-ink-90 leading-none whitespace-nowrap">
                    {option.nativeLabel}
                  </span>
                ) : null}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
